// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"422":"media-overlay","715":"details-modal","835":"variant-selection"}[chunkId] + ".css";
};